<div class="total-price" [class.total-price--currency-dialog-visible]="isCurrencyDialogVisible">
  <div class="total-price__content-left">
    <div class="total-price__quote-breakdown" (click)="toggleBreakdown()" *ngIf="handheld$ | async">
      <div class="total-price__quote-breakdown__icon">
        <i class="pi pi-chevron-up"></i>
      </div>
      <div class="total-price__quote-breakdown__link" i18n data-qa="packageDetails_quoteBreakdown_link">Details</div>
    </div>
    <div>
      <div class="total-price__price">
        <span class="total-price__value" data-qa="total-price-value">
          {{ grandTotal$ | async | lxPrice : { currency: (currency$ | async), showCurrency: false } }}
        </span>
        <lx-currency-selector
          [currency]="selectedCurrency$ | async"
          [singleCurrencyMode]="singleCurrencyMode$ | async"
          [availableCurrencies]="availableCurrencies$ | async"
          (currencySelected)="onCurrencySelected($event)"
          (dialogVisibilityChange)="onCurrencySelectorDialogOpen($event)"
          class="total-price__currency"
          data-qa="total-price-currency-button"
        ></lx-currency-selector>
      </div>
      <div *ngIf="handheld$ | async" class="total-price__title" data-qa="total-price-title" i18n>
        Enrol today for {{ depositAmounts$ | async | lxPrice : { currency: currency$ | async } }}
      </div>
    </div>
  </div>
  <div class="total-price__quote-breakdown" (click)="toggleBreakdown()" *ngIf="(handheld$ | async) === false">
    <div
      class="total-price__quote-breakdown__link"
      (keydown)="handleBreakdownKeydown($event)"
      tabindex="0"
      role="button"
      aria-label="Show quote breakdown details"
      i18n
      data-qa="totalPrice_quoteBreakdown_link"
    >
      Quote details
    </div>
  </div>
  <div *ngIf="enabledBookNow">
    <lx-button
      [class.total-price__button--adult]="(activeFlow$ | async) === Flows.Adult"
      [class.total-price__button--junior]="(activeFlow$ | async) === Flows.Junior"
      size="s"
      text="Enrol"
      i18n-text
      [hasText]="true"
      [block]="true"
      tabindex="0"
      [tabindex]="'-1'"
      [btnRounded]="true"
      [buttonStyle]="'primary'"
      data-qa="total-price-book-now-button"
      [lxNavigationToStep]="nextStep$ | async | async"
      [gaEvent]="quoteEnrolEventName"
    >
    </lx-button>
  </div>
</div>

<lx-side-panel
  i18n-title
  title="Your quote breakdown"
  [autoFocus]="true"
  [visible]="quoteBreakdownVisible$ | async"
  (hiddenPanel)="hideBreakdown()"
  data-qa="totalPrice_quoteBreakdown_sidePanel"
>
  <lx-quote-breakdown></lx-quote-breakdown>

  <div class="total-price__quote-breakdown-footer" ngProjectAs="footer">
    <lx-button
      i18n-text
      text="Back"
      [block]="true"
      [btnRounded]="true"
      [buttonStyle]="'primary'"
      icon="pi pi-arrow-left"
      iconPos="before"
      tabindex="0"
      [tabindex]="'-1'"
      (keydown.enter)="hideBreakdown()"
      (buttonClick)="hideBreakdown()"
      [class.package-details__quote-breakdown-footer__back-button--adult]="(activeFlow$ | async) !== Flows.Junior"
      [class.package-details__quote-breakdown-footer__back-button--junior]="(activeFlow$ | async) === Flows.Junior"
      data-qa="totalPrice_quoteBreakdown_backButton"
    >
    </lx-button>
  </div>
</lx-side-panel>
